import ACSLogo from '@/assets/images/acs.svg';

const AzureIcon = ({ size = 25 }) => (
    <img
        src={ACSLogo}
        alt="Azure Communication Services Logo"
        style={{ height: size, width: size }}
    />
);

export default AzureIcon;
